import React from 'react';
import { resourcePieces } from '../../data/landing';
import { WorksheetMock } from '../WorksheetMock';
export function ResourcesSection() {
  return <section className="bg-cream py-12 sm:py-24" data-id="element-309" data-mp="22v4cq5rv8lxu">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-310" data-mp="26y0vbwheoi1s">
        <div className="grid items-center gap-7 lg:grid-cols-[1.2fr_1fr] lg:gap-12" data-id="element-311" data-mp="26wg2cbaqp761">
          <div className="order-2 lg:order-1" data-id="element-312" data-mp="2bwucpzztct78">
            <div role="img" aria-label="Ficha de evaluación inicial, plan de intervención y sesión lista del kit, impresas en español" className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl bg-beige-200" data-id="element-313" data-mp="1f7wicivz6xal">
              <div className="absolute left-[4%] top-[8%] w-[46%] -rotate-[5deg]" data-id="element-314" data-mp="1o7027p2yvgq5">
                <WorksheetMock variant="ficha" data-id="element-315" data-mp="1szb3owdcvakt" />
              </div>
              <div className="absolute left-[30%] top-[14%] z-10 w-[44%] rotate-[1.5deg]" data-id="element-316" data-mp="1t0m6otyz8eav">
                <WorksheetMock variant="sesion" data-id="element-317" data-mp="vhaw4xbegqho" />
              </div>
              <div className="absolute right-[3%] top-[6%] w-[42%] rotate-[6deg]" data-id="element-318" data-mp="10h5n10v6dg2q">
                <WorksheetMock variant="plan" data-id="element-319" data-mp="1i9cdfo66vu80" />
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-320" data-mp="1e9v7ktmuov2b">
            <h2 className="font-serif text-[1.9rem] leading-tight text-petrol-800 sm:text-5xl" data-id="element-321" data-mp="1eb6c4vo4e6uh">
              No es solo material <span className="italic text-terra-500" data-id="element-322" data-mp="14j8yli9n32sl">para leer.</span>
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-ink/75 sm:mt-5 sm:text-lg" data-id="element-323" data-mp="14h67sw0nx5mt">
              Es una <strong className="text-petrol-800" data-id="element-324" data-mp="zhjoq5y5kv63">biblioteca de recursos</strong> para consultar, adaptar y utilizar en
              tu práctica profesional.
            </p>

            <ul className="mt-5 flex flex-wrap gap-2 sm:mt-8" data-id="element-325" data-mp="qjho3ric04jc">
              {resourcePieces.map(({
              label,
              icon: Icon
            }) => <li key={label} className="group flex items-center gap-2 rounded-full border border-beige-200 bg-paper py-1.5 pl-1.5 pr-3.5 transition-colors duration-150 ease-out hover:border-terra-300 hover:bg-terra-50" data-id="element-326" data-mp="2kxse43anx4qp">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage-100 text-petrol-700 transition-colors duration-150 ease-out group-hover:bg-terra-500 group-hover:text-cream" data-id="element-327" data-mp="2z1zewjqzm7r4">
                    <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-328" data-mp="2q3npgl1uxg09" />
                  </span>
                  <span className="text-sm font-medium text-petrol-800" data-id="element-329" data-mp="2v1p8j5za9fbq">{label}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}